var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { initEmbedManager } from 'logi-embed/EmbedManager';
/**
 * Wrapper For Rendering Logi Embedded Component.
 */
export const LogiComponent = ({ componentType, configuration, getToken, logiBaseUrl, styleWidth, styleHeight, ariaLabel, }) => {
    const [loading, setLoading] = useState(false);
    const logiRendered = React.useRef(false);
    const logiElement = React.useRef(null);
    const embedManager = React.useRef(null);
    const logiComponentId = React.useRef(null);
    useEffect(() => {
        const renderLogiComponent = () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            const embedManagerPromise = initEmbedManager({
                getToken: () => __awaiter(void 0, void 0, void 0, function* () {
                    const result = yield getToken();
                    return { access_token: result.access_token, expires_in: result.expires_in };
                }),
            }, logiBaseUrl + '/composer');
            embedManager.current = yield embedManagerPromise;
            const component = yield embedManager.current.createComponent(componentType, configuration);
            logiComponentId.current = component.componentInstanceId;
            if (logiElement.current) {
                component.render(logiElement.current, { width: '100%', height: '100%' });
            }
            setLoading(false);
        });
        if (logiElement.current && !logiRendered.current) {
            renderLogiComponent();
            logiRendered.current = true;
        }
        return () => {
            if (embedManager.current && logiComponentId.current) {
                embedManager.current.removeComponent(logiComponentId.current);
            }
            embedManager.current = undefined;
            logiComponentId.current = undefined;
        };
    }, []);
    return (React.createElement(Box, null,
        loading ? React.createElement(CircularProgress, null) : React.createElement(React.Fragment, null),
        React.createElement(Box, { sx: { flexDirection: 'column' } },
            React.createElement(Box, { ref: logiElement, sx: {
                    flex: 'flex-grow',
                    flexGrow: 1,
                    position: 'relative',
                    width: styleWidth ? styleWidth : '100%',
                    height: styleHeight ? styleHeight : '70vh',
                }, "aria-label": `${ariaLabel} container` }))));
};
